import { NgModule } from '@angular/core';
import {
  CmsConfig,
  GlobalMessageConfig,
  GlobalMessageType,
  I18nConfig,
  OccConfig,
  provideConfig,
  provideConfigFactory,
  SiteContextConfig,
  SiteThemeConfig,
} from '@spartacus/core';
import {
  defaultCmsContentProviders,
  ImageLoadingStrategy,
  layoutConfigFactory,
  mediaConfig,
  MediaConfig,
} from '@spartacus/storefront';

const BASE_URL = 'https://localhost:9002';
// const BASE_URL = 'https://api-hisense.cdrwhdl6-hisenseeu2-p1-public.model-t.cc.commerce.ondemand.com';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfigFactory(layoutConfigFactory),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({ checkout: { guest: true } }),
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: BASE_URL,
          prefix: '/ggcommercewebservices/v2/',
          endpoints: {
            // product: 'products/pdp/${productCode}',
            product: {
              default:
                'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),baseOptions,baseProduct,variantOptions,variantType,trafficLightCode,reviews(FULL)',
            },
            baseSites: 'basesites/config',
            productSearch:
              'products/search?fields=products(url,code,name,ean,summary,configurable,configuratorType,multidimensional,price(FULL),images(DEFAULT),stock(FULL),averageRating,numberOfReviews,variantOptions,badges(FULL),factsPDPDocument(FULL),modelMark,mainCategoryName,airConditionerSeries,categoryHierarchy(DEFAULT),technicalDesc,trafficLightCode),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
            category: '/catalogs/${catalogId}/${catalogVersionId}/categories/${categoryId}',
            news: '/news?start=${start}&count=${count}',
            addSelectedPayment:
              '/users/${userId}/carts/${cartId}/payment/ggPayments/addSelected?selectedPaymentMethod=${selectedPayment}',
            getSelectedPayment: '/users/${userId}/carts/${cartId}/payment/ggPayments/getSelected',
            nestpayAuthorization: '/users/${userId}/carts/${cartId}/payment/ggPayments/nestpay_authorization',
            checkoutBillingAddress: '/users/${userId}/carts/${cartId}/addresses/billing',
            checkoutSelectBillingAddress: '/users/${userId}/carts/${cartId}/addresses/billing?addressId=${addressId}',
            orderDetails: '/orders/${orderId}?fields=FULL',
            orderExists: '/orders/${orderId}/exists',
            store: 'stores/${storeId}?fields=FULL',
            stores:
              'stores?fields=stores(name,displayName,formattedDistance,openingHours(weekDayOpeningList(FULL),specialDayOpeningList(FULL)),geoPoint(latitude,longitude),address(line1,line2,town,region(FULL),postalCode,phone,country,email,url),features),pagination(DEFAULT),sorts(DEFAULT)',
            currentUser: '/users/${userId}',
            // pages: '/cms/approvedPages',
            pages: '/cms/localizedLabelPages',
            klarna: '/users/${userId}/carts/${cartId}/payment/ggPayments/payWithKlarna',
            megapos: '/users/${userId}/carts/${cartId}/payment/ggPayments/megapos',
            subscriptionByLocation: '/subscription/location/${location}',
            subscriptions: '/subscription/subscriptions',
            subscribe: '/subscription/subscribe',
            unsubscribe: '/subscription/unsubscribe',
            subscribeRegisterCDC: '/subscription/subscribeRegisterCDC',
            remindUser: '/products/${productCode}/remind',
            productModelSearchSuggest: '/productModelSearch/suggest',
            productModelSearchFind: '/productModelSearch/find',
            stripe: '/users/${userId}/carts/${cartId}/payment/ggPayments/stripe',
            getCdcConsent: '/subscription/getAllConsents',
            getLiteAccountCdc: '/subscription/cdc/liteusersearch?email=${email}',
            faq: 'faqs/${id}',
            dcc: 'bv/dcc',
            monri: '/users/${userId}/carts/${cartId}/payment/ggPayments/monri',
            simplepay: '/users/${userId}/carts/${cartId}/payment/ggPayments/simplepay',
            gpwebpay: '/users/${userId}/carts/${cartId}/payment/ggPayments/gpwebpay',
            leanpay: '/users/${userId}/carts/${cartId}/payment/ggPayments/leanpay',
            payway: '/users/${userId}/carts/${cartId}/payment/ggPayments/payway',
            paypal: '/users/${userId}/carts/${cartId}/payment/ggPayments/paypal',
            lufcId: '/customers/${userId}/lufcId',
            shouldChangePriceWithCustomerPriceGroup:
              '/customers/${userId}/shouldChangePriceWithCustomerPriceGroup/${productCode}',
            productHighlight: 'products/highlighted/${productCode}?retailerAction=${retailerActionCode}',
            partnerLinkList: 'products/fetchRetailers',
            recaptchaV3CheckResponse: '/recaptchaV3/checkCaptcha?response=${response}',
            recaptchaV2CheckResponse: '/recaptchaV2/checkCaptcha?response=${response}',
            installmentPayments: '/payment/ggPayments/installments/${paymentMethod}?price=${price}',
            restoreCart: '/cart/restore/${cartGuid}',
            oldApplianceRemoval:
              '/users/${userId}/carts/${cartId}/oldApplianceRemoval?applianceRemoval=${applianceRemoval}',
            translations: '/basesites/dynamic-translations/hisense-storefront/{{ns}}/{{lng}}',
            addBundle: 'users/${userId}/carts/${cartId}/addBundle',
            removeBundle: 'users/${userId}/carts/${cartId}/removeBundle',
            // /{baseSiteId}/users/{userId}/carts
            productOfTheMonth: 'products/productOfTheMonth',
            loadCheckoutDetails:
              'users/${userId}/carts/${cartId}?fields=deliveryAddress(FULL),deliveryMode,paymentInfo(FULL),collectLocation',
            cart: 'users/${userId}/carts/${cartId}?fields=DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),totalUnitCount,deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,%20value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description,paymentAddress(FULL)',
            productVerification: 'recall/appliance',
            firmwareVerification: 'firmware/${extraId}',
            aiTroubleshootCheckAppliance: 'faqs-ai/search/${auidOrSn}/exists',
            aiTroubleshootIssueDescription: '/faqs-ai/search/${auidOrSn}/issue',
          },
        },
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {
        //   currency: ['EUR'],
        //   language: ['sl'],
        //   baseSite: ['hisense-si'],
      },
    }),
    /*Do not remove the following provideConfig.
      Otherwise, it tries to load local translations.*/
    provideConfig(<I18nConfig>{ i18n: { backend: { loadPath: 'dynamic-translations' } } }),
    provideConfig(<MediaConfig>{ imageLoadingStrategy: ImageLoadingStrategy.LAZY }),
    provideConfig(<GlobalMessageConfig>{
      globalMessages: {
        [GlobalMessageType.MSG_TYPE_ERROR]: { timeout: 60000 },
        [GlobalMessageType.MSG_TYPE_INFO]: { timeout: 60000 },
        [GlobalMessageType.MSG_TYPE_CONFIRMATION]: { timeout: 60000 },
        [GlobalMessageType.MSG_TYPE_WARNING]: { timeout: 60000 },
      },
    }),
    provideConfig(<CmsConfig>{
      anonymousConsents: {
        requiredConsents: ['ESSENTIAL'],
      },
    }),
    provideConfig(<SiteThemeConfig>{
      siteTheme: {
        optionalThemes: [
          {
            i18nNameKey: 'siteThemeSwitcher.themes.dark',
            className: 'cx-theme-dark',
          },
          {
            i18nNameKey: 'siteThemeSwitcher.themes.highContrastLight',
            className: 'cx-theme-high-contrast-light',
          },
          {
            i18nNameKey: 'siteThemeSwitcher.themes.highContrastDark',
            className: 'cx-theme-high-contrast-dark',
          },
        ],
      },
    }),
  ],
})
export class SpartacusConfigurationModule {}
